import { HeroIcon } from '@components/HeroIcon'
import { useTranslation } from 'react-i18next'
import { Text, XStack, YStack } from 'tamagui'
import { Button } from '@components/Button'

export function CommentEmptyState({ onPress }: { onPress: () => void }) {
  const { t } = useTranslation('Comments')

  return (
    <YStack>
      <XStack
        mb="$spacing-inset-xs"
        gap="$spacing-inset-nano"
        alignItems="center"
        testID="comments-empty-state"
      >
        <HeroIcon
          icon={['fal', 'comments']}
          size={32}
          color="$text-placeholder"
        />
        <Text
          flex={1}
          flexShrink={1}
          flexWrap="wrap"
          fontFamily="$mulishRegular"
          fontSize="$font-size-xxs"
          color="$text-muted"
        >
          {t('emptyState.description')}
        </Text>
      </XStack>
      <Button variant="primary" onPress={onPress}>
        {t('emptyState.cta')}
      </Button>
    </YStack>
  )
}
